import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PolicyStudioComponent } from './policy-studio.component';
import {ActionBarModule} from '../../../components/action-bar/action-bar.module';
import {MaterialModule} from '../../../material.module';
import {VirtualScrollerModule} from 'ngx-virtual-scroller';
import {PolicyStudioActionBoxComponent} from './policy-studio-action-box/policy-studio-action-box.component';
import {PolicyStudioMatchBoxComponent} from './policy-studio-match-box/policy-studio-match-box.component';
import { PolicyStudioDialogComponent } from './policy-studio-dialog/policy-studio-dialog.component';
import {FormsModule} from '@angular/forms';
import {InfraModule} from 'ac-infra';
import {SelectFromDualListModule} from '../../../utils/select-from-dual-list/select-from-dual-list.module';
import {ArmFormTitleModule} from '../../../components/arm-form/arm-form-title/arm-form-title.module';
import {ChooseTopologyItemModule} from '../../../utils/choose-topology-item/choose-topology-item.module';
import {NzPopoverModule} from 'ng-zorro-antd/popover';


@NgModule({
  declarations: [
    PolicyStudioComponent,
    PolicyStudioActionBoxComponent,
    PolicyStudioMatchBoxComponent,
    PolicyStudioDialogComponent
  ],
  imports: [
    CommonModule,
    ActionBarModule,
    MaterialModule,
    VirtualScrollerModule,
    FormsModule,
    InfraModule,
    SelectFromDualListModule,
    ArmFormTitleModule,
    ChooseTopologyItemModule,
    NzPopoverModule
  ]
})
export class PolicyStudioModule { }
